import React from 'react';
import { IconProps } from '.';

const SvgCircleCheckFillBold = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm-1.19 12.605-2.646-2.352-1.328 1.494 4.102 3.648 6.292-6.711-1.46-1.368-4.96 5.29Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCircleCheckFillBold;
